import { combineReducers, Reducer as ReduxReducer } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import { PersistConfig } from 'redux-persist/es/types';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import storage from 'redux-persist/lib/storage';
import sessionStorage from 'redux-persist/lib/storage/session';
import AuthSlice from './auth/Auth.slice';
import CommonSlice from './common/common.slice';
import MfilesConfigSlice from './mfilesConfig/mfilesConfig.slice';
import { api } from './RTKQuery/api';
import SheetConfigSlice from './sheetConfig/sheetConfig.slice';
import SheetDataSlice from './sheetData/sheetData.slice';

// Auth persist config (local storage)
const authPersistConfig: PersistConfig<ReturnType<typeof AuthSlice>> = {
  key: 'auth',
  storage: storage,
  // whitelist: [],
  stateReconciler: autoMergeLevel2,
};

// MFiles config persist config (session storage)
const mfilesConfigPersistConfig: PersistConfig<
  ReturnType<typeof MfilesConfigSlice>
> = {
  key: 'mfilesConfig',
  // whitelist: [],
  storage: sessionStorage,
  stateReconciler: autoMergeLevel2,
};

// First, persist individual slices that need different storage types
const persistedAuthSlice = persistReducer<ReturnType<typeof AuthSlice>>(
  authPersistConfig,
  AuthSlice
);

const persistedMfilesConfigSlice = persistReducer<
  ReturnType<typeof MfilesConfigSlice>
>(mfilesConfigPersistConfig, MfilesConfigSlice);

// combine all reducers (some persisted, some not)
const rootReducer: ReduxReducer = combineReducers({
  auth: persistedAuthSlice,
  sheetData: SheetDataSlice,
  mfilesConfig: persistedMfilesConfigSlice,
  sheetConfig: SheetConfigSlice,
  common: CommonSlice,
  [api.reducerPath]: api.reducer,
}) as ReduxReducer;

// the root reducer
export const persistedReducer = rootReducer;
